export const isFalsy = <T = unknown>(value: T) => {
  if (value === 0) {
    return false
  }

  return !value
}
